// Keep campaign attribution in the URL or page memory; never add tracking storage.
export function readCampaignParameters(search) {
  const params = new URLSearchParams(search);
  const campaign = {};
  for (const key of ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term']) {
    const values = params.getAll(key);
    if (values.length === 1 && /^[a-zA-Z0-9][a-zA-Z0-9_-]{0,119}$/.test(values[0])) {
      campaign[key] = values[0];
    }
  }
  return campaign;
}

export function campaignLink(href, sourceUrl) {
  const source = new URL(sourceUrl);
  const destination = new URL(href, source);
  if (destination.origin !== source.origin) return href;
  for (const [key, value] of Object.entries(readCampaignParameters(source.search))) {
    destination.searchParams.set(key, value);
  }
  return destination.pathname + destination.search + destination.hash;
}
